<template>
  <hs-dialog v-model="currentShow">
    <div class="sortDialog van-safe-area-bottom">
      <c-dialog-header :title="title" style="flex-shrink: 0" />
      <hs-scroll ref="tableView" class="tableView">
        <div class="select-list" @click.stop>
          <hs-cell-1
            v-for="(item, i) in data"
            :showLogo="false"
            :showSeparator="false"
            :key="item.text"
            @click.native="() => select(item, i)">
            <div class="custom-cell" :class="{ active: sort === i }">
              <span>{{ item.text }}</span>
              <span class="subtext" v-if="item.subtext">{{ item.subtext }}</span>
            </div>
            <img v-if="sort === i" class="icon-select" :src="require('@/assets/image/base/check-box/icons_16pt_right.png')" alt="" />
          </hs-cell-1>
          <div style="height: 30px"></div>
        </div>
      </hs-scroll>
      <footer v-if="showConfirm">
        <hs-button width="100%" height="38px" :fontSize="null" type="theme" @click="_getDatalist">{{$t('Confirm')}}</hs-button>
      </footer>
    </div>
  </hs-dialog>
</template>
<script type="text/ecmascript-6">

import CDialogHeader from "@/components/c-header/c-dialog-header.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import HsCell1 from "@/base/hs-tableview/hs-cell-1/hs-cell-1.vue";
import HsDialog from "@/base/hs-dialog/hs-dialog.vue";
import HsScroll from "@/base/hs-scroll/hs-scroll.vue";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    selected: {
      type: [String, Number],
      default: null
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  components: {
    HsScroll,
    CDialogHeader,
    HsButton,
    HsCell1,
    HsDialog
  },
  watch: {
    show(val) {
      if (val) {
        this.sort = null
        this.data.map((item, i) => {
          if (item.value === this.selected) {
            this.sort = i
          }
        })
      }
    }
  },
  data() {
    return {
      sort: null,
    }
  },
  computed: {
    currentShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    open() {
      this.$emit('update:show', true)
    },
    close() {
      this.$emit('update:show', false)
    },
    select(item, i) {
      this.sort = i
      if (!this.showConfirm) {
        this._getDatalist()
      }
    },
    _getDatalist() {
      let i = this.sort
      let item = this.data[i]
      if (item && item.text) {
        let val = [item.value]
        let index = [i]
        let text = [item.text]
        this.$emit('selected', val, index, text)
      }
      this.currentShow = false
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.sortDialog {
  @extend .flex-column;
  @extend .flex-start;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: $color_black_0;
  border-radius: 10px 10px 0 0;
  max-height: 80vh;
  min-height: 40vh;
  :deep(.hs-cell-1) {
    > .details > .logo{
      width: 16px;
      height: 16px;
    }
  }
  .tableView {
    max-height: calc(80vh - 48px);
    min-height: calc(40vh - 48px);
    width: 100%;
    overflow: hidden;
  }
  .select-list {
    width: 100%;
  }
  .title {
    @extend .hs-font-subtitle-big;
    display: flex;
    justify-content: center;
    width: 100%;
    padding-left: 20px;
  }
  .custom-cell {
    @extend .flex-start;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    min-height: 56px;
    padding: 5px 0;
    line-height: 1.2em;
    font-size: 0.8rem;
    color: $color_black_text_0;
    word-break: break-all;
    span {
      @extend .hs-font-body;
    }
    .subtext {
      @extend .hs-font-caption-1;
      color: $color_black_100;
    }
  }
  .icon-select {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
  .active {
    color: $color_theme;
    .subtext {
      color: $color_theme;
    }
  }
  footer{
    width: 100%;
    padding: 16px 12px;
  }
}
</style>
